import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 用户登录接口 
export const userLogin = (params) => { return loginreq("post", "/web/login/userLogin", params) };
// 专家登录接口 
export const agentLogin = (params) => { return loginreq("post", "/web/login/agentLogin", params) };
// 管理登录接口 
export const adminLogin = (params) => { return loginreq("post", "/web/login/adminLogin", params) };
// 获取验证码 
export const getVerifyCode = (params) => { return loginreq("post", "/web/login/getCode", params) };
// 用户注册 
export const userRegister = (params) => { return loginreq("post", "/web/login/userRegister", params) };
// 获取ICP备案信息 
export const getIPCConfig = (params) => { return loginreq("post", "/web/login/getIPCConfig", params) };


// 用户相关接口开始

// 获取用户菜单权限
export const getUserAuthMenu = (params) => { return req("post", "/admin/user/getUserAuthMenu", params) };
// 获取用户基本信息
export const getUserInfo = (params) => { return req("post", "/web/user/getUserInfo", params) };
// 获取用户按钮权限
export const getUserAuthBtn = (params) => { return req("post", "/admin/user/getUserAuthBtn", params) };
// 编辑用户基本信息
export const editCustomer = (params) => { return req("post", "/web/user/editCustomer", params) };
// 查询客户列表
export const getCustomerPageList = (params) => { return req("post", "/web/user/getCustomerPageList", params) };
// 检索专利
export const searchPatent = (params) => { return req("post", "/web/patent/searchPatent", params) };
// 专利价值评估专利信息查询
export const searchReportPatent = (params) => { return req("post", "/web/patent/searchReportPatent", params) };
// 用户查询价值评估报告
export const getEvalReport = (params) => { return req("post", "/web/patent/getEvalReport", params) };
// 查询评估价格
export const getOrderConfig = (params) => { return req("post", "/web/order/getOrderConfig", params) };
// 创建订单(单件评估)
export const createReportOrderByOne = (params) => { return req("post", "/web/order/createReportOrderByOne", params) };
// 创建订单(批量评估)
export const createReportOrderByMore = (params) => { return req("post", "/web/order/createReportOrderByMore", params) };
// 查询价值评估列表
export const getEvalOrderPageList = (params) => { return req("post", "/web/order/getEvalOrderPageList", params) };
// 查询价值评估订单详情
export const getEvalOrderInfo = (params) => { return req("post", "/web/order/getOrderInfo", params) };
// 积分支付订单
export const orderPayByPoints = (params) => { return req("post", "/web/order/orderPayByPoints", params) };
// 创建积分充值订单
export const createRechargeOrder = (params) => { return req("post", "/web/order/createRechargeOrder", params) };
// 查询用户积分充值订单列表
export const getUserRechargeOrderPageList = (params) => { return req("post", "/web/order/getUserRechargeOrderPageList", params) };
// 查询用户积分充值订单详情
export const getRechargeOrderInfo = (params) => { return req("post", "/web/order/getRechargeOrderInfo", params) };
// 用户删除积分充值订单
export const cusDelChargeOrder = (params) => { return req("post", "/web/order/delChargeOrder", params) };
// 用户查询积分日志
export const getCusPointsLog = (params) => { return req("post", "/web/user/getUserPointsLog", params) };
// 用户查询对公转账信息
export const getTransferAccountConfig = (params) => { return req("post", "/web/user/getTransferAccountConfig", params) };
// 创建积分充值转账单
export const createRechargeTaxOrder = (params) => { return req("post", "/web/order/createRechargeTaxOrder", params) };
// 查询客户发票抬头列表
export const getUserInvoicePageList = (params) => { return req("post", "/web/user/getUserInvoicePageList", params) };
// 编辑客户发票抬头
export const editInvoice = (params) => { return req("post", "/web/user/editInvoice", params) };
// 删除客户发票抬头
export const delInvoice = (params) => { return req("post", "/web/user/delInvoice", params) };
// 用户修改密码
export const changeUserPassword = (params) => { return req("post", "/web/user/changeUserPassword", params) };
// 用户查询可申请开发票的充值订单数据
export const getCanApplyTicketOrder = (params) => { return req("post", "/web/user/getCanApplyTicketOrder", params) };
// 用户导出选中的评估记录
export const exportCheckEvalData = (params) => { return req("post", "/web/order/exportCheckEvalData", params) };



// 用户相关接口结束


// 管理端相关接口开始
// 查询管理账户基本信息

// 查询账户基本信息
export const getAdminInfo = (params) => { return req("post", "/web/admin/getAdminInfo", params) };
// 查询管理账户列表
export const getAdminPageList = (params) => { return req("post", "/web/admin/getAdminPageList", params) };
// 查询账户按钮权限
export const getAdminBtn = (params) => { return req("post", "/web/admin/getAdminBtn", params) };
// 查询用户列表
export const getUserPageList = (params) => { return req("post", "/web/admin/getUserPageList", params) };
// 获取管理账户权限
export const getAdminPermission = (params) => { return req("post", "/web/admin/getUserPageList", params) };
// 查询权限菜单列表
export const getPermissionPageList = (params) => { return req("post", "/web/admin/getPermissionPageList", params) };
// 编辑权限菜单
export const editPermission = (params) => { return req("post", "/web/admin/editPermission", params) };
// 查询系统配置数据列表
export const getSysConfigPageList = (params) => { return req("post", "/web/admin/getSysConfigPageList", params) };
// 编辑系统配置
export const editSysConfig = (params) => { return req("post", "/web/admin/editSysConfig", params) };
// 删除系统配置
export const delSysConfig = (params) => { return req("post", "/web/admin/delSysConfig", params) };
// 查询系统角色列表
export const getSysRolePageList = (params) => { return req("post", "/web/admin/getSysRolePageList", params) };
// 编辑系统角色
export const editSysRole = (params) => { return req("post", "/web/admin/editSysRole", params) };
// 删除系统角色
export const delSysRole = (params) => { return req("post", "/web/admin/delSysRole", params) };
// 查询角色权限菜单
export const getRoleInfo = (params) => { return req("post", "/web/admin/getRoleInfo", params) };
// 查询所有的权限菜单
export const getAuthMenu = (params) => { return req("post", "/web/admin/getAuthMenu", params) };
// 修改管理员账户密码
export const changeAdminPassword = (params) => { return req("post", "/web/admin/changeAdminPassword", params) };
// 查询发票申请数据
export const getApplyTicketPageList = (params) => { return req("post", "/web/admin/getApplyTicketPageList", params) };
// 查询积分充值订单数据
export const getRechargeOrderPageList = (params) => { return req("post", "/web/admin/getRechargeOrderPageList", params) };
// 查询案件订单数据
export const getEvalCaseOrderPageList = (params) => { return req("post", "/web/admin/getEvalCaseOrderPageList", params) };
// 管理员导出勾选的案件
export const importEvalCaseCheck = (params) => { return req("post", "/web/order/importEvalCaseCheck", params) };
// 管理员审核转账凭证
export const examineTransfer = (params) => { return req("post", "/web/admin/examineTransfer", params) };
// 用户提交发票申请
export const addInvoiceApply = (params) => { return req("post", "/web/user/addInvoiceApply", params) };
// 管理员提交发票
export const editInvoiceTicket = (params) => { return req("post", "/web/admin/editInvoiceTicket", params) };
// 管理员查询评估案件订单
export const getSysCasePageList = (params) => { return req("post", "/web/order/getSysCasePageList", params) };
// 管理员查询用户积分记录
export const getAdminCusPointsLog = (params) => { return req("post", "/web/admin/getAdminCusPointsLog", params) };
// 管理员手动给用户充值积分
export const rechargePointsToCus = (params) => { return req("post", "/web/admin/rechargePointsToUser", params) };
// 管理员编辑用户账户
export const adminEditUser = (params) => { return req("post", "/web/admin/adminEditUser", params) };
// 查询系统角色
export const getSysRole = (params) => { return req("post", "/web/admin/getSysRole", params) };
// 编辑管理员账户
export const editAdmin = (params) => { return req("post", "/web/admin/editAdmin", params) };

// 图表统计
// 查询可选年份
export const getSelectYearData = (params) => { return req("post", "/web/platform/getSelectYearData", params) };
// 查询领域分布图表数据
export const getSysAdminAreaData = (params) => { return req("post", "/web/platform/getSysAdminAreaData", params) };
// 查询级别分布图表数据
export const getSysAdminLevelData = (params) => { return req("post", "/web/platform/getSysAdminLevelData", params) };
// 查询评估数量图表数据
export const getSysAdminEvalNumData = (params) => { return req("post", "/web/platform/getSysAdminEvalNumData", params) };
// 查询用户排行图表数据
export const getCustomerRankData = (params) => { return req("post", "/web/platform/getUserRankData", params) };
// 查询专利权人图表数据
export const getAgentRankData = (params) => { return req("post", "/web/platform/getPatentEeRankData", params) };


// 管理端相关接口结束

// 定时任务
// 查询客户列表
export const handlePatentData = (params) => { return req("post", "/patent/task/handleEvaluateTaskData", params) };

export const webUrl = 'http://evaluate.value/index.php';
export const docUrl = 'http://evaluate.value';
// export const webUrl = 'http://evaluate.test/index.php';



// WEBPACK FOOTER //
// ./src/api/evalMG.js